// extracted by mini-css-extract-plugin
export var integrationButton = "_72-0";